module.exports = __webpack_public_path__ + "ea11799c85d395cd559d8b9b9ed2ea2e.MP3";